import { render, staticRenderFns } from "./IcoVideoContent.vue?vue&type=template&id=23936244"
import script from "./IcoVideoContent.vue?vue&type=script&lang=js"
export * from "./IcoVideoContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports